import Vue from "vue";
import Vuex, { Module, StoreOptions } from "vuex";
import { Namespace } from "./types";
import { RootState } from "./RootState";
import { auth } from "@/components/auth/store";
import { player } from "@/components/player/store";
import { alert } from "@/components/alert/store";
import { channelChange } from "@/components/channelChange/store";
import { overlay } from "@/components/overlay/store";
import { sideBar } from "@/components/sidebar/store";
import { channelsPage } from "@/components/channelsPage/store";
import { homePage } from "@/components/homePage/store";
import { buffet } from "@/components/buffet/store";
import { settings } from "@/components/settings/store";
import { vod } from "@/components/VoD/store";

Vue.use(Vuex);

const storeOptions: StoreOptions<RootState> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modules: Record<Namespace, Module<any, RootState>>;
} = {
  state: {
    version: "1.0.0"
  },
  modules: {
    [Namespace.Auth]: auth,
    [Namespace.Player]: player,
    [Namespace.Alert]: alert,
    [Namespace.ChannelChange]: channelChange,
    [Namespace.Overlay]: overlay,
    [Namespace.SideBar]: sideBar,
    [Namespace.ChannelsPage]: channelsPage,
    [Namespace.HomePage]: homePage,
    [Namespace.Buffet]: buffet,
    [Namespace.Settings]: settings,
    [Namespace.Vod]: vod
  }
};

const store = new Vuex.Store<RootState>(storeOptions);
export default store;
